import { BodyText } from '@calendly/ui/components/typography'
import { colorTextActionContrast } from '@calendly/ui/theme'

import { Button, Description } from './styles'

// role is needed for accessibility
export const Option = ({ name, description, example, kind, poolingType, onClick, ...props }) => (
  <Button onClick={() => onClick(kind, poolingType)} {...props}>
    {typeof name === 'string' ? <BodyText color={colorTextActionContrast} weight="bold">{name}</BodyText> : name}
    {description && <Description>{description}</Description>}
    <BodyText color="muted" size="medium">{example}</BodyText>
  </Button>
)
